import { DefaultOptionType } from 'antd/es/select';
import React, { FC, memo, useCallback, useMemo } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { RentState } from 'entities/Invoice';
import { Select } from 'shared/ui/Select';
import { BoxesListFilterKeys } from '../../model/types';

interface BoxTypeSelectProps {
  value: string;
  onChange: (value: string, label: string) => void;
  onClear: (filterKey: string) => void;
}

export const BoxTypeSelect: FC<BoxTypeSelectProps> = memo((props) => {
  const { value, onChange, onClear } = props;

  const { t } = useAppTranslation('boxes');

  const boxTypeOptions = useMemo<Array<{ label: string; value: RentState }>>(() => {
    return [
      { label: t('Active reservation'), value: RentState.ACTIVE_RESERVATION },
      { label: t('Active contract'), value: RentState.ACTIVE_CONTRACT },
      { label: t('Available'), value: RentState.AVAILABLE },
    ];
  }, [t]);

  const handleChange = useCallback(
    (value: string, option?: DefaultOptionType | DefaultOptionType[]): void => {
      if (!Array.isArray(option) && typeof option?.label === 'string') {
        onChange(value, option.label);
      }
    },
    [onChange],
  );

  const clearFilter = useCallback(() => {
    onClear(BoxesListFilterKeys.type);
  }, [onClear]);

  return (
    <Select
      containerClassName="flex-1"
      className="w-full"
      label={t('Type')}
      placeholder={t('All')}
      bordered
      allowClear
      options={boxTypeOptions}
      value={value}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
